var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhyUsIco3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 44,
    viewBox: "0 0 46 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8958 29.5441L22.8749 25.8037L26.8541 29.5441",
    stroke: "url(#paint0_linear_2332_188)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.875 22.0632V25.8036",
    stroke: "url(#paint1_linear_2332_188)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8751 8.98145C24.4553 8.98145 25.9709 9.57153 27.0883 10.6219C28.2057 11.6723 28.8334 13.0968 28.8334 14.5823V16.5406H16.9167V14.5823C16.9167 13.0968 17.5445 11.6723 18.6619 10.6219C19.7793 9.57153 21.2948 8.98145 22.8751 8.98145Z",
    stroke: "url(#paint2_linear_2332_188)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8749 8.98157C25.0726 8.98157 26.8541 7.30692 26.8541 5.24115C26.8541 3.17537 25.0726 1.50073 22.8749 1.50073C20.6773 1.50073 18.8958 3.17537 18.8958 5.24115C18.8958 7.30692 20.6773 8.98157 22.8749 8.98157Z",
    stroke: "url(#paint3_linear_2332_188)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7917 35.1448C40.3719 35.1448 41.8874 35.7349 43.0048 36.7853C44.1222 37.8356 44.75 39.2602 44.75 40.7456V42.704H32.8125V40.7456C32.8125 40.0085 32.9673 39.2786 33.268 38.5978C33.5688 37.917 34.0095 37.2987 34.565 36.7783C35.1205 36.258 35.7798 35.8458 36.5051 35.5655C37.2304 35.2852 38.0075 35.1422 38.7917 35.1448Z",
    stroke: "url(#paint4_linear_2332_188)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7917 35.1449C40.9893 35.1449 42.7708 33.4703 42.7708 31.4045C42.7708 29.3387 40.9893 27.6641 38.7917 27.6641C36.594 27.6641 34.8125 29.3387 34.8125 31.4045C34.8125 33.4703 36.594 35.1449 38.7917 35.1449Z",
    stroke: "url(#paint5_linear_2332_188)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95833 35.145C7.74079 35.145 8.51559 35.2899 9.23849 35.5714C9.96139 35.8528 10.6182 36.2654 11.1715 36.7855C11.7248 37.3056 12.1637 37.923 12.4631 38.6025C12.7625 39.282 12.9167 40.0103 12.9167 40.7459V42.7042H1V40.7459C1 39.2604 1.62775 37.8358 2.74516 36.7855C3.86256 35.7351 5.37809 35.145 6.95833 35.145Z",
    stroke: "url(#paint6_linear_2332_188)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95842 35.1449C9.15605 35.1449 10.9376 33.4703 10.9376 31.4045C10.9376 29.3387 9.15605 27.6641 6.95842 27.6641C4.76078 27.6641 2.97925 29.3387 2.97925 31.4045C2.97925 33.4703 4.76078 35.1449 6.95842 35.1449Z",
    stroke: "url(#paint7_linear_2332_188)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2332_188",
    x1: 22.8746,
    y1: 25.8037,
    x2: 22.8746,
    y2: 29.5439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4167B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2332_188",
    x1: 23.375,
    y1: 22.0632,
    x2: 23.375,
    y2: 25.8034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4167B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2332_188",
    x1: 22.8746,
    y1: 8.98145,
    x2: 22.8746,
    y2: 16.5401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4167B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2332_188",
    x1: 22.8746,
    y1: 1.50073,
    x2: 22.8746,
    y2: 8.98111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4167B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2332_188",
    x1: 38.7808,
    y1: 35.1448,
    x2: 38.7808,
    y2: 42.7035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4167B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2332_188",
    x1: 38.7914,
    y1: 27.6641,
    x2: 38.7914,
    y2: 35.1444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4167B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2332_188",
    x1: 6.95789,
    y1: 35.145,
    x2: 6.95789,
    y2: 42.7037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4167B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2332_188",
    x1: 6.95812,
    y1: 27.6641,
    x2: 6.95812,
    y2: 35.1444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4167B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyUsIco3);
export default __webpack_public_path__ + "static/media/why-us-ico-3.ec0699dbc49f88d5a626c192a4bdb571.svg";
export { ForwardRef as ReactComponent };